// 没有mock的axios实例
import axiosWithoutMock, { deleteHttp, getHttp, postHttp } from './axios';

export const axios = axiosWithoutMock;

function objectHumpToLine(obj) {
    var newObj = new Object();
    for (let key in obj) {
        newObj[key.replace(/([A-Z])/g, "_$1").toLowerCase()] = obj[key];
    }
    return newObj;
};

function searchPatients(params) {
    return getHttp('/patients/search', params);
}
function getPatientList() {
    return getHttp('/patients');
}
function addPatient(data) {
    return postHttp('/patients', data);
}
function deletePatient(id) {
    return axios.delete('/patients?patientId=' + id);
}
function updatePatient(data, id) {
    return postHttp(`/patientManagement/edit?patientId=${id}`, data);
}

function getHearinginstruments(params) {
    let finalyParams = {
        groupType: "Family",
        styles: "NotSet",
        features: "NotSet",
        condition: "",
        page: "1",
        pageSize: "6"
    };
    if (params) {
        Object.assign(finalyParams, params);
    }

    return getHttp('/fitting/hearingInstrument/selection/filter', finalyParams);
}

function getHearingDevice() {
    return getHttp('/fitting/hearingInstrument/selection');
    // return axios.get('/fitting/hearingInstrument/selection');
}
function setHearingDevice(params) {
    return postHttp(`/fitting/hearingInstrument/selection?side=${params.side}&hiType=${params.hiType}`);
}

export function deleteSelection(side) {
    return deleteHttp(`/fitting/hearingInstrument/selection?side=${side}`);
}

function getHearingDeviceCateCategory() {
    return getHttp('/hearingInstruments/catalogSettings');
}

function getSessions(params) {
    return getHttp('/sessions', params);
}

function addSession(data) {
    return postHttp('/sessions', data);
}

function getSessionoverview(patientId) {
    return getHttp(`/patientManagement/sessionoverviews?patientId=${patientId}`);
}


function loadSession(patientId, sessionId) {
    return getHttp(`/patientManagement/session?patientId=${patientId}&sessionId=${sessionId}`);
}

export function getSelectionHearingInstrument() {
    return getHttp("/fitting/hearingInstrument/selection");
}

export function getHIConfiguration() {
    return getHttp("/fitting/hearingInstrument/configuration");
}
export function upateConfiguration(data) {
    return postHttp("/fitting/hearingInstrument/configuration/update", data);
}

export function getHiColorDetail() {
    return getHttp("/fitting/hearingInstrument/configuration/image");
}
export function setHiColorDetail(data) {
    return postHttp(`fitting/hearingInstrument/configuration/image`, data);
}
export function getHiImageUrl() {
    return getHttp("fitting/hearingInstrument/configuration/show");
}

export function setHIExperience(v) {
    return postHttp(`fitting/hearingInstrument/configuration?experience=${v}`);
}

export function getHIDetailCouping() {
    return getHttp(`fitting/hearingInstrument/configuration/coupling`);
}

export function setHIDetailCouping(isCoupling) {
    return postHttp(`fitting/hearingInstrument/configuration/coupling?isCoupling=${isCoupling}`);
}

export function setSelectToolState(side) {
    return postHttp(`fitting/hearingInstrument/configuration/toolState?side=${side}`);
}
export function getWXINfo(code) {
    return axios.post(`users/weChat?code=${code}`);
}

const api = {
    searchPatients,
    getPatientList,
    addPatient,
    deletePatient,
    updatePatient,
    getHearinginstruments,
    getHearingDevice,
    getHearingDeviceCateCategory,
    getSessions,
    addSession,
    getSessionoverview,
    loadSession,
    setHearingDevice,
};

export default api;

